import hlxLockup from '~/assets/logo-hlx-header.png';
import hlxIcon from '~/assets/logo-hlx-mark.png';

interface HlxLogoProps {
  // `icon` forces the square X-mark only (tight spots: mobile drawers, slide-out panels).
  // Any other value renders the responsive header logo (icon on small screens, full
  // "Healthcare Labor Exchange" lockup at `xl`+). `none`/`below`/`side` are kept for
  // backward-compatible call sites and all resolve to the responsive header logo.
  label?: 'none' | 'below' | 'side' | 'icon';
  height?: number;
}

export const HlxLogo = ({ label, height = 32 }: HlxLogoProps) => {
  if (label === 'icon') {
    return (
      <img
        src={hlxIcon}
        alt="HealthcareLX"
        style={{ maxHeight: height }}
        className="h-auto w-auto"
      />
    );
  }

  // The lockup is ~10.5:1 — at height 32 it's ~338px wide, which doesn't fit
  // alongside the full nav until `xl`, so show the square icon up to `xl` and the
  // full lockup at `xl`+ (below that the nav would overflow). Purely CSS, no
  // media-query hook. `shrink-0` keeps the wide lockup at its natural aspect ratio
  // — without it a flex parent compresses the width and the default
  // object-fit:fill stretches "Healthcare Labor Exchange" (see MCV-1487).
  return (
    <>
      <img
        src={hlxIcon}
        alt="HealthcareLX"
        style={{ maxHeight: height }}
        className="h-auto w-auto lg:hidden"
      />
      <img
        src={hlxLockup}
        alt="HealthcareLX"
        // MCV-1487: allow narrow header columns to scale both dimensions together.
        // A fixed height combined with Tailwind's max-width constraint squashed this
        // unusually wide lockup horizontally.
        style={{ maxHeight: height }}
        className="hidden h-auto w-auto lg:block"
      />
    </>
  );
};
